/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { PageQueryParams, SearchQueryParams } from '../apiCommon.typings';

export interface ShortUserDto {
    id: number;
    firstName: string;
    lastName: string;
}

export enum UserRole { //to be used only in adminUsersScreen
    Inspector = 'INSPECTOR',
    Director = 'DIRECTOR',
    Expert = 'EXPERT',
    Auditor = 'AUDITOR',
    Operator = 'OPERATOR',
    Taxpayer = 'TAXPAYER',
    RegionalInspector = 'REGIONAL_INSPECTOR',
    CentralInspector = 'CENTRAL_INSPECTOR',
}

export enum LoginFormType {
    Inspector = 'INSPECTOR',
    Operator = 'OPERATOR',
    Taxpayer = 'TAXPAYER',
}

export interface DetailedUserDto {
    id: number;
    status: UserStatus;
    firstName: string;
    lastName: string;
    middleName?: string;
    registrationAtUtc: string;
    deactivationDate?: string;
    email: string;
    phone?: string;
    roles: UserRole[];
    operatorName?: string; // for operators
    taxAuthorityId?: string; // for inspectors
    taxAuthorityName?: string; // for inspectors

    [key: string]: number | string | UserRole[];
}

export interface AdminUsersListDto {
    count: number;
    users: DetailedUserDto[];
}

export enum UserStatus {
    Active = 'ACTIVE',
    Inactive = 'INACTIVE',
    Deleted = 'DELETED',
}

export type AdminUsersListQueryParams = PageQueryParams & AdminUsersListFilterParams;

export interface AdminUsersListFilterParams extends Partial<SearchQueryParams> {
    status?: UserStatus[];
    roles?: UserRole[];
    taxAuthorityId?: string[];
    operatorTaxNumber?: string[];
}

//for added and edited users
export interface NewUserData {
    firstName: string;
    middleName?: string;
    lastName: string;
    email: string;
    phone?: string;
    roles: UserRole[];
    taxAuthorityId?: string;
    password: string;

    [key: string]: string | UserRole[];
}
